import React from 'react';
import { Box, FlexList, useI18nContext } from '@procore/core-react';
import { Typography } from '@mui/material';
import { useStyles } from './BusinessLicense.styles';
import { License } from '../../types/business';

interface Props {
  buinessLicense: License;
}

const LicenseRow = ({ property, value }) => {
  const classes = useStyles();
  return (
    <FlexList className={classes.container} justifyContent="space-between">
      <Typography className={classes.property} textAlign="left">
        {property}
      </Typography>
      <Typography className={classes.value} textAlign="right">
        {value}
      </Typography>
    </FlexList>
  );
};

const BuinessLicense = ({ buinessLicense }: Props) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  return (
    <Box className={classes.wrapper}>
      <LicenseRow
        property={I18n.t(
          'pages.p.business_profile_layout.business_profile_licenses.state'
        )}
        value={buinessLicense.state}
      />

      <LicenseRow
        property={I18n.t(
          'pages.p.business_profile_layout.business_profile_licenses.license_number'
        )}
        value={buinessLicense.licenseNumber}
      />

      <LicenseRow
        property={I18n.t(
          'pages.p.business_profile_layout.business_profile_licenses.issue_date'
        )}
        value={buinessLicense.issueDate}
      />

      <LicenseRow
        property={I18n.t(
          'pages.p.business_profile_layout.business_profile_licenses.expiration_date'
        )}
        value={buinessLicense.expirationDate}
      />

      <LicenseRow
        property={I18n.t(
          'pages.p.business_profile_layout.business_profile_licenses.classification'
        )}
        value={buinessLicense.classification}
      />
    </Box>
  );
};

export default BuinessLicense;
